import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadCommissions = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      minWidth: "30px",
      width: "30px",
      align: "left",
    },
    {
      title: "Operadora",
      minWidth: "150px",
      align: "left",
      width: "150px",
    },
    {
      title: "Modalidade",
      minWidth: "150px",
      width: "150px",
      align: "left",
    },
    {
      title: "Administradora",
      minWidth: "150px",
      width: "150px",
      align: "left",
    },
    {
      title: "Empresa",
      minWidth: "150px",
      width: "150px",
      align: "left",
    },
    {
      title: "Vigência",
      minWidth: "100px",
      align: "center",
      width: "100px",
      infoTitle: "Comissão valida a partir desta data",
    },
    {
      title: "Comissão",
      minWidth: "90px",
      align: "center",
      width: "90px",
    },
    {
      title: "Ativa",
      minWidth: "80px",
      align: "center",
      width: "80px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
